<bom-workspace>
  <ng-container *ngIf="mitIdSigneringRequest && !showSpinner">
    <iframe
      id="signing-window"
      width="100%"
      height="700"
      frameBorder="0"
      [src]="safeSigningClientUrl"
    ></iframe>
  </ng-container>
  <ng-container *ngIf="showSpinner">
    <bom-spinner [message]="spinnerText"></bom-spinner>
  </ng-container>
</bom-workspace>
